import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from './portal/components/loader/loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title: string = 'web.app.jnardc';
  visitorCount: number = 0;

  ngOnInit() {
    this.updateVisitorCount();
  }
  // This approach tracks unique visitors over time (e.g., count once per 24 hours).
  updateVisitorCount() {
    const lastVisit = localStorage.getItem('lastVisit');
    const now = new Date().getTime();
    const oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    if (!lastVisit || now - parseInt(lastVisit, 10) > oneDay) {
      // Get visitor count
      const count = localStorage.getItem('visitorCount');
      this.visitorCount = count ? parseInt(count, 10) + 1 : 1;

      // Update count in localStorage
      localStorage.setItem('visitorCount', this.visitorCount.toString());

      // Update last visit timestamp
      localStorage.setItem('lastVisit', now.toString());
    } else {
      // If within 24 hours, just get the existing count
      const count = localStorage.getItem('visitorCount');
      this.visitorCount = count ? parseInt(count, 10) : 0;
    }
  }
}
